module.exports = __webpack_public_path__ + "img/vip-free.aa229615.png";